interface StripeLogoIconProps {
  className?: string;
}

export function StripeLogoIcon({ className }: StripeLogoIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 38.4615 16.1582"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <title>Stripe</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.4615 8.34876C38.4615 5.58742 37.1367 3.40854 34.6047 3.40854C32.062 3.40854 30.5235 5.58742 30.5235 8.32719C30.5235 11.5739 32.3397 13.2135 34.9466 13.2135C36.2179 13.2135 37.1795 12.9222 37.906 12.5124V10.3551C37.1795 10.7218 36.3462 10.9483 35.2885 10.9483C34.2521 10.9483 33.3333 10.5816 33.2158 9.30876H38.4402C38.4402 9.16854 38.4615 8.60764 38.4615 8.34876ZM33.1838 7.32405C33.1838 6.10517 33.9209 5.5982 34.594 5.5982C35.2457 5.5982 35.9402 6.10517 35.9402 7.32405H33.1838Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3996 3.40854C25.3526 3.40854 24.6795 3.90472 24.3056 4.24989L24.1667 3.58112H21.8162V16.1582L24.4872 15.5865L24.4979 12.5339C24.8825 12.8144 25.4487 13.2135 26.3889 13.2135C28.3013 13.2135 30.0427 11.6602 30.0427 8.2409C30.0321 5.11281 28.2692 3.40854 26.3996 3.40854ZM25.7585 10.8405C25.1282 10.8405 24.7543 10.6139 24.4979 10.3335L24.4872 6.33169C24.765 6.01888 25.1496 5.80315 25.7585 5.80315C26.7308 5.80315 27.4038 6.90337 27.4038 8.31641C27.4038 9.7618 26.7415 10.8405 25.7585 10.8405Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.141 2.77214L20.8226 2.18966V2.58242e-07L18.141 0.571686V2.77214Z"
        fill="#635BFF"
      />
      <path d="M20.8226 3.59191H18.141V13.0301H20.8226V3.59191Z" fill="#635BFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2671 4.39011L15.0962 3.59191H12.7885V13.0301H15.4594V6.63371C16.0897 5.80315 17.1581 5.95416 17.4893 6.07281V3.59191C17.1474 3.46247 15.8974 3.22517 15.2671 4.39011Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.92521 1.25124L7.31838 1.81214L7.30769 10.4521C7.30769 12.0485 8.49359 13.2243 10.0748 13.2243C10.9509 13.2243 11.5919 13.0625 11.9444 12.8683V10.6787C11.6026 10.8189 9.91453 11.3151 9.91453 9.71865V5.88944H11.9444V3.59191H9.91453L9.92521 1.25124Z"
        fill="#635BFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.70299 6.33169C2.70299 5.91101 3.04487 5.74921 3.61111 5.74921C4.42308 5.74921 5.44872 5.9973 6.26068 6.43955V3.90472C5.37393 3.54876 4.49786 3.40854 3.61111 3.40854C1.44231 3.40854 0 4.55191 0 6.46112C0 9.4382 4.05983 8.9636 4.05983 10.2472C4.05983 10.7434 3.63248 10.9052 3.03419 10.9052C2.14744 10.9052 1.01496 10.5384 0.117521 10.0422V12.6094C1.11111 13.0409 2.11538 13.2243 3.03419 13.2243C5.25641 13.2243 6.78419 12.1133 6.78419 10.1825C6.7735 6.96809 2.70299 7.53978 2.70299 6.33169Z"
        fill="#635BFF"
      />
    </svg>
  );
}
